import axios from 'axios';

export default {
  // getHome (second) { // 투데이 가장 위, 스토리 모음
  //   return new Promise((resolve, reject) => {
  //     axios.get(`/v4/home`, {params: {
  //       time: second,
  //     }}).then((response) => {
  //       if (response.data) resolve(response.data);
  //       reject(response);
  //     }).catch(reject);
  //   });
  // },
  // getHomeCommunity (page, second, count) { // 투데이 커뮤니티 섹션
  //   return new Promise((resolve, reject) => {
  //     axios.get(`/v4/home/community`, {params: {
  //       time: second,
  //       page,
  //       count,
  //     }}).then((response) => {
  //       if (response.data) resolve(response.data);
  //       reject(response);
  //     }).catch(reject);
  //   });
  // },
  getHome (second) { // 리뉴얼 홈 가장 위 유학 선택 필드, 인기 top5 스코리
    return new Promise((resolve, reject) => {
      axios.get(`/v5/home`, {params: {
        time: second,
      }}).then((response) => {
        if (response.data) resolve(response.data);
        reject(response);
      }).catch(reject);
    });
  },
  getCommunity (second, page, keyword, menuIdx, nationIdx) { // 리뉴얼 커뮤니티 탭
    return new Promise((resolve, reject) => {
      axios.get(`/v5/community`, {params: {
        page,
        count: 20,
        time: second,
        keyword,
        menu_idx: menuIdx,
        nation_idx: nationIdx
      }}).then((response) => {
        if (response.data) resolve(response.data);
        reject(response);
      }).catch(reject);
    });
  },
  getStore (second, page) {
    return new Promise((resolve, reject) => {
      axios.get(`/v5/store`, {params: {
        page,
        count: 16,
        time: second,
      }}).then((response) => {
        if (response.data) resolve(response.data);
        reject(response);
      }).catch(reject);
    });
  },
  getCuration (second) { // 투데이 큐레이션
    return new Promise((resolve, reject) => {
      axios.get(`/v5/curation`, {params: {
        time: second,
      }}).then((response) => {
        if (response.data) resolve(response.data);
        reject(response);
      }).catch(reject);
    });
  },
  getSubjectChannel (subjectIdx, sectionIdx) { // 투데이 -> 주제 더보기
    return new Promise((resolve, reject) => {
      axios.get(`/v3/subject/${subjectIdx}/channel`, {params: {
        curation_subject_idx: sectionIdx,
      }}).then((response) => {
        if (response.data) resolve(response.data);
        reject(response);
      }).catch(reject);
    });
  },
  getSubscribeChannel (second, page) { // 구독중인 채널 목록
    return new Promise((resolve, reject) => {
      axios.get(`/v3/subscribe/channel`, {params: {
          time: second,
          page,
          count: 10,
      }}).then((response) => {
        if (response.data) resolve(response.data);
        reject(response);
      }).catch(reject);
    });
  },
  getSubscribePost (second, page) { // 구독중인 채널의 읽지 않은 포스트 카운터 & 포스트 목록
    return new Promise((resolve, reject) => {
      axios.get(`/v3/subscribe/post`, {params: {
          time: second,
          page,
          count: 10,
      }}).then((response) => {
        if (response.data) resolve(response.data);
        reject(response);
      }).catch(reject);
    });
  },
  getPushCount () { // 푸시 알람 카운트
    return new Promise((resolve, reject) => {
      axios.get(`/v3/push/count`).then((response) => {
        if (response.data) resolve(response.data);
        reject(response);
      }).catch(reject);
    });
  },
  getPush (second, page) { // 푸시 알람 목록
    return new Promise((resolve, reject) => {
      axios.get(`/v3/push`, {params: {
          time: second,
          page,
          count: 20,
      }}).then((response) => {
        if (response.data) resolve(response.data);
        reject(response);
      }).catch(reject);
    });
  },
}
